module.exports = __webpack_public_path__ + "img/vote_platinum.1150a427.png";